
import {Component, Prop, Vue} from 'vue-property-decorator'
import {IOption} from '@/components/lib/models'
import {VNode} from 'vue'

@Component
export default class PolicyChapter extends Vue {

  @Prop() readonly root?: string
  @Prop() readonly title?: string
  @Prop({ default: false }) readonly strong?: boolean

  get prefix(): string {
    return this.fill(this.root);
  }

  get nodes(): IOption<any>[] {
    return this.$slots.default?.map((slot, index) => ({
      name: this.fill(this.prefix + (index + 1)),
      value: slot.elm as HTMLElement
    })) || [];
  }

  private fill(value?: string, filler: string = '.'): string {
    return value ? (value + filler) : '';
  }

  render(createElement: any) {
    let strong = this.strong ? 'strong' : '';
    let children: VNode[] = [];

    let defaultVNodeFields = {
      isRootInsert: false,
      isComment: false
    }
    // header
    children.push({
      tag: 'p',
      data: {
        class: this.fill(strong, ' ') + 'lg chapter-label'
      },
      text: this.fill(this.root, '. ') + this.title,
      ...defaultVNodeFields
    });
    // nodes
    let nodeSlots = this.$slots.default;
    if (nodeSlots?.length) {
      children.push({
        tag: 'div',
        data: {
          class: 'chapter-content'
        },
        children: nodeSlots.map((slot: VNode, index: number) => ({
          ...slot,
          children: [
            {
              tag: 'span',
              text: this.fill(this.prefix + (index + 1), '. '),
              ...defaultVNodeFields
            },
            ...slot.children || []
          ]
        })),
        ...defaultVNodeFields
      });
    }
    return createElement('div', {}, children);
  }

}
